import { PROJECTS_SET, PROJECT_EDITED, PROJECT_ADDED, PROJECT_DELETED } from 'src/app/redux/redux-types';
import { reduxProjectsTypes } from 'src/types';

export const projectsDefaultState: reduxProjectsTypes.StateType = {
  projectsList: [],
};

export const projectsReducer = (
  state = projectsDefaultState,
  action: reduxProjectsTypes.ActionType,
): reduxProjectsTypes.StateType => {
  switch (action.type) {
    case PROJECTS_SET:
      return {
        ...state,
        projectsList: action.payload,
      };
    case PROJECT_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.projectsList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        projectsList: [action.payload, ...state.projectsList],
      };
    case PROJECT_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.projectsList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        projectsList: [
          ...state.projectsList.slice(0, updateIndex),
          action.payload,
          ...state.projectsList.slice(updateIndex + 1),
        ],
      };
    case PROJECT_DELETED:
      return {
        ...state,
        projectsList: state.projectsList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
